<div class="its-course-catalogue-coursecard">
    <a class="its-course-catalogue-coursecard__main" href={courseLink}>
        <div class="its-course-catalogue-coursecard__top">
            {#if courseCardImageUrl}
                <img class="its-course-catalogue-coursecard__image" src={courseCardImageUrl} alt="">
            {/if}

            <div class="its-course-catalogue-coursecard__section">
                <div class="its-course-catalogue-coursecard__title">{title}</div>

                {#if description}
                    <div class="its-course-catalogue-coursecard__description">{description}</div>
                {/if}

                {#if teacherProfile}
                    <div class="its-course-catalogue-coursecard__teachers">
                        <Profile name={teacherProfile.profileNames} src={teacherProfile.profileAvatars} size={200} />
                    </div>
                {/if}
            </div>
        </div>

            <div class="its-course-catalogue-coursecard__bottom">
                {#if targetRole || subject || educationalLevel}
                <CourseCardProperties {targetRole} {subject} {educationalLevel}/>
                {/if}
                {#if isUserEnrolled}
                    <CourseCardStatus/>
                {/if}
            </div>
    </a>
</div>

<script lang="ts">
    import Profile from "@itslearning/prometheus/assets/nodes/Profile/v1/Profile.svelte";
    import CourseCardProperties from './CourseCardProperties.svelte';
    import CourseCardStatus from "./CourseCardStatus.svelte";
    import type { CatalogueCourseTeacherModel } from '../../api/api.ts';

    export let courseCardImageUrl: string = '';
    export let courseLink: string = '';
    export let title: string = '';
    export let description : string= '';
    export let teachers: CatalogueCourseTeacherModel[] = [];
    export let targetRole: string = '';
    export let subject: string = '';
    export let educationalLevel: string = '';
    export let isUserEnrolled: boolean = false;

    const teacherProfile = getProfileNamesAndAvatars(teachers);

    /**
     * Builds title and extracts avatars for Profile control
     * @param teachers - teachers
     */
    function getProfileNamesAndAvatars(teachers: CatalogueCourseTeacherModel[]) {
        if (!teachers.length) {
            return null;
        }

        const profileNames = teachers.length > 1 ? `${teachers[0].fullName} +${teachers.length - 1}` : teachers[0].fullName;
        const profileAvatars = teachers.map(teacher => teacher.personPictureUrl);

        return { profileNames, profileAvatars };
    }
</script>
